import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import FJTrimAction from '@src/redux/action/FJTrimAction.ts';
import styles from './FJFoot.module.less';
import FJButton, { FJButtonType } from '@src/common/components/FJButton/FJButton.tsx';
import FJLocalStore from '@src/store/FJLocalStore';
import FJTimeDisplayScreen from '@src/components/FJModals/FJAdjustDurationModal/modules/FJTimeDisplayScreen.tsx';
import { FJModalsAction } from '@src/redux/action/FJModalsAction.ts';
import FJToolTip from '@src/common/components/FJToolTip/FJToolTip';

const FJFootContainer = () => {
    const dispatch = useAppDispatch();

    const duration = useAppSelector(state => {
        const s = state.modal.cut;
        return s.endTime - s.startTime;
    });

    const onCancel = () => {
        dispatch(FJTrimAction.cancelAction());
    };

    const onSave = () => {
        dispatch(FJTrimAction.saveAction());
    };

    const changeUnitConversion = (value: number) => {
        dispatch(FJTrimAction.setUnitConversionAction(value));
    };

    const fitOnClickHandler = () => {
        dispatch(FJTrimAction.fitUnitConversionAction());
    };

    return (
        <div className={styles.box}>
            {/*<div className={styles.slider_box}>*/}
            {/*    <FJFitBox*/}
            {/*        maxZoom={maxUnitConversion}*/}
            {/*        minZoom={minUnitConversion}*/}
            {/*        zoom={unitConversion}*/}
            {/*        step={minUnitConversion}*/}
            {/*        placement='top'*/}
            {/*        zoomOutDisabled={unitConversion <= minUnitConversion}*/}
            {/*        zoomInDisabled={unitConversion >= maxUnitConversion}*/}
            {/*        onChangeZoom={changeUnitConversion}*/}
            {/*        fitOnClickHandler={fitOnClickHandler}*/}
            {/*    />*/}
            {/*</div>*/}
            {/*<div className={styles.timeBox}>*/}
            {/*    <FJTimeDisplayScreen />*/}
            {/*</div>*/}
            <div className={styles.btn_box}>
                <FJButton
                    text={FJLocalStore._('cancel')}
                    type={FJButtonType.DEFAULT}
                    className={styles.btn}
                    onClick={onCancel}
                />
                {duration > 1 ? (
                    <FJButton
                        text={FJLocalStore._('save')}
                        type={FJButtonType.GRADIENT}
                        className={styles.btn}
                        onClick={onSave}
                    />
                ) : (
                    <FJToolTip
                        title={FJLocalStore._('The video duration must be at least 1 seconds')}
                        placement={'top'}
                    >
                        <div className={styles.no_active_btn}>{FJLocalStore._('save')}</div>
                    </FJToolTip>
                )}
            </div>
        </div>
    );
};

export default FJFootContainer;
